import React, { useEffect } from 'react';
import { useUploadContext } from 'context/UploadVideoContext';
import FailureUpload from '../components/UploadFailed';
import SuccessUpload from '../components/UploadSuccess';
import { Steps, VideoAnalysisSubmissionProps } from '../types';

export function VideoSuccessFailure({ setSteps }: VideoAnalysisSubmissionProps) {
  const { uploadProgress, errorUpload } = useUploadContext();
  const fullProgress = 100;

  useEffect(() => {
    if (uploadProgress === fullProgress && !errorUpload) {
      setSteps(Steps.ResultForm);
    }
  }, [uploadProgress, errorUpload, setSteps]);

  return (
    <div className="flex flex-col p-6">
      {errorUpload ? (
        <FailureUpload errorUpload={errorUpload} />
      ) : (
        !!uploadProgress && <SuccessUpload uploadProgress={uploadProgress} />
      )}
    </div>
  );
}

export default VideoSuccessFailure;
